import { ChangeEventHandler, FC, ReactNode } from "react"

export interface FormSelectOption {
  value: string
  label: ReactNode
  disabled?: boolean
}

interface FormSelectProps {
  label?: ReactNode
  name: string
  value: string
  onChange: ChangeEventHandler<HTMLSelectElement>
  options: FormSelectOption[]
  helpText?: ReactNode
  disabled?: boolean
}

/**
 * Generic labelled <select>
 */
export const FormSelect: FC<FormSelectProps> = ({ label, name, value, onChange, options, helpText, disabled = false }) => (
  <div>
    {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{label}</label>}
    <select
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="w-full px-4 py-2 border border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)] rounded-lg dark:bg-[rgba(0,0,0,0.2)] dark:text-white focus:border-[rgba(139,92,246,0.5)] focus:outline-none transition-all disabled:cursor-not-allowed disabled:opacity-50"
    >
      {options.map((opt) => (
        <option key={opt.value || "none"} value={opt.value} disabled={opt.disabled}>
          {opt.label}
        </option>
      ))}
    </select>
    {helpText && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{helpText}</p>}
  </div>
)
